import { jsx as _jsx } from "react/jsx-runtime";
const DropdownArrowIcon = (props) => {
    return (_jsx("svg", Object.assign({ width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: _jsx("path", { d: "M7.41 8.58008L12 13.1701L16.59 8.58008L18 10.0001L12 16.0001L6 10.0001L7.41 8.58008Z", fill: props.color }) })));
};
DropdownArrowIcon.defaultProps = {
    color: 'black',
};
export default DropdownArrowIcon;
